"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bosco-chiesanuova": {
    "01983aa0": [{
      "hkey": "bc32def7",
      "slug": "lughezzano",
      "name": "Lughezzano",
      "primary": true,
      "skipSearch": false
    }],
    "lughezzano-arzere": [{
      "hkey": "bc32def7",
      "slug": "lughezzano",
      "name": "Lughezzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b9f126cf": [{
      "hkey": "b8e34f8b",
      "slug": "malga-san-giorgio",
      "name": "Malga San Giorgio",
      "primary": true,
      "skipSearch": false
    }],
    "malga-san-giorio": [{
      "hkey": "b8e34f8b",
      "slug": "malga-san-giorgio",
      "name": "Malga San Giorgio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;